import {
  type GetQualifiedWorkplacesRequest,
  getQualifiedWorkplacesRequestSchema,
  type QualifiedWorkplacesResponse,
  qualifiedWorkplacesResponseSchema,
} from "@clipboard-health/contract-worker-app-bff";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  type QueryFunctionContext,
  type QueryKey,
  useInfiniteQuery,
  type UseInfiniteQueryOptions,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";

const QUALIFIED_WORKPLACES_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/qualified-workplaces`;

export function getQualifiedWorkplacesQueryKey(params: GetQualifiedWorkplacesRequest) {
  return [QUALIFIED_WORKPLACES_URL, params];
}

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface UseQualifiedWorkplacesOptions
  extends UseInfiniteQueryOptions<QualifiedWorkplacesResponse, AxiosError> {}

export function useQualifiedWorkplaces(
  params: GetQualifiedWorkplacesRequest,
  options: UseQualifiedWorkplacesOptions = {}
) {
  return useInfiniteQuery({
    queryKey: getQualifiedWorkplacesQueryKey(params),
    queryFn: async ({
      pageParam: pageParameter,
    }: QueryFunctionContext<
      QueryKey,
      string | undefined
    >): Promise<QualifiedWorkplacesResponse> => {
      const response = await get({
        url: QUALIFIED_WORKPLACES_URL,
        queryParams: {
          ...params,
          page: {
            ...params.page,
            cursor: pageParameter,
          },
        },
        requestSchema: getQualifiedWorkplacesRequestSchema,
        responseSchema: qualifiedWorkplacesResponseSchema,
      });

      return response.data;
    },
    getNextPageParam: (lastPage: QualifiedWorkplacesResponse) =>
      lastPage.links?.nextCursor ?? undefined,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_QUALIFIED_WORKPLACES_FAILURE,
    },
    ...options,
  });
}
